// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-8282178a]{fill:#3f3f3f}.cls-2[data-v-8282178a]{fill:#b2b2b2}.cls-3[data-v-8282178a]{fill:#656565}.cls-4[data-v-8282178a]{fill:#fff}.cls-5[data-v-8282178a]{-webkit-filter:url(#Rechteck_287);filter:url(#Rechteck_287)}", ""]);
// Exports
module.exports = exports;
